import React from 'react';

const GenerationsInHouseholdFilterIcon = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x="7.75" y="2.75" width="4.5" height="4.5" rx="1.25" strokeWidth="1.5" />
    <rect x="3.75" y="11.75" width="4.5" height="4.5" rx="1.25" strokeWidth="1.5" />
    <rect x="11.75" y="11.75" width="4.5" height="4.5" rx="1.25" strokeWidth="1.5" />
    <path d="M5.25 11.5C5.25 11.9142 5.58579 12.25 6 12.25C6.41421 12.25 6.75 11.9142 6.75 11.5H5.25ZM6 9.5V8.75C5.58579 8.75 5.25 9.08579 5.25 9.5H6ZM14 9.5H14.75C14.75 9.08579 14.4142 8.75 14 8.75V9.5ZM13.25 11.5C13.25 11.9142 13.5858 12.25 14 12.25C14.4142 12.25 14.75 11.9142 14.75 11.5H13.25ZM10.75 7.5C10.75 7.08579 10.4142 6.75 10 6.75C9.58579 6.75 9.25 7.08579 9.25 7.5H10.75ZM6.75 11.5V9.5H5.25V11.5H6.75ZM13.25 9.5V11.5H14.75V9.5H13.25ZM6 10.25H10V8.75H6V10.25ZM10 10.25H14V8.75H10V10.25ZM10.75 9.5V7.5H9.25V9.5H10.75Z" />
  </svg>
);

export default GenerationsInHouseholdFilterIcon;
